import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

const useToolbarStyles = makeStyles((theme) => ({
  // root: {
  //   paddingLeft: theme.spacing(2),
  //   paddingRight: theme.spacing(1),
  // },
  gameComponent: {
    // alignSelf: 'column',
    // justifyContent: 'center',
    // margin: 'auto',
    marginBottom: '40px',
    marginTop: '40px',
    // marginBottom: '40px',
    // marginTop: '40px',
    border: '2px solid white',
    height: 'auto',
  },
}));

const GameComponent = ({ children }) => {
  const classes = useToolbarStyles();


  return (
    <Grid className={classes.gameComponent}>
      {children}
    </Grid>
  );
}

export default GameComponent;